import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './nav.css'
import styles from './nav.module.css'

function Navb() {
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);

    // Carga el idioma guardado al inicio
    useEffect(() => {
        const savedLanguage = localStorage.getItem('preferredLanguage');
        if (savedLanguage) {
            navigate(`/${savedLanguage}`);
        }
    }, [navigate]);

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 50; // Cambia el número si quieres más o menos scroll
            setScrolled(isScrolled);
        };
    
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
        }, []);

        // Cambia el idioma y redirige
    const handleLanguageChange = (language) => {
        localStorage.setItem('preferredLanguage', language);
        navigate(`/${language}`);
    };
return (
<Navbar
    collapseOnSelect
    expand="lg"
    className={`${styles.bgnav} ${scrolled ? styles.navbarScrolled : styles.navbarTransparent}`}>
    <Container>
    <Navbar.Brand href="#home" className={styles.logo}>LAUTARO MAZZA</Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ms-auto">
        <Nav.Link href="#sobremi" className={styles.navitem}>ABOUT ME</Nav.Link>
        <Nav.Link href="#galeria" className={styles.navitem}>GALERY</Nav.Link>
        <Nav.Link href="#clases" className={styles.navitem}>CLASSES</Nav.Link>
        <Nav.Link href="#eventosprivados" className={styles.navitem}>PRIVATE EVENTS</Nav.Link>
        <Nav.Link href="#prensa" className={styles.navitem}>PRESS</Nav.Link>
        <Nav.Link href="#contacto" className={styles.navitem}>CONTACT</Nav.Link>
        <NavDropdown className={styles.navitem} title="LAN" id="basic-nav-dropdown">
            <NavDropdown.Item onClick={() => handleLanguageChange('es')}>SPANISH</NavDropdown.Item>
            <NavDropdown.Item onClick={() => handleLanguageChange('en')}>
            ENGLISH
            </NavDropdown.Item>
        </NavDropdown>
        </Nav>
    </Navbar.Collapse>
    </Container>
</Navbar>
);
}

export default Navb;